import { useCallback } from 'react';
import { AlertTriangleIcon, PaletteIcon } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Card, CardHeader } from '@/components/ui/card';
import { useFetch } from '@/hooks/useFecth';
import { useClub } from '../ClubContext';
import AppImageClub from '../components/AppImageClub';
import BannersClubCard from '../components/BannersClubCard';
import CardImageClub from '../components/CardImageClub';
import ClubSettingsCardHeader from '../components/ClubSettingsCardHeader';
import DesignClub from '../components/DesignClub';
import DetailsClub from '../components/DetailsClub';
import DominioClub from '../components/DominioClub';
import FeaturedHighlightClub from '../components/FeaturedHighlightClub';
import MenuClubCard from '../components/MenuClubCard';
import SeoClub from '../components/SeoClub';
import SocialLinksClub from '../components/SocialLinksClub';

export default function SettingsClub() {
    const { data, mutate } = useFetch('club');
    const { reloadHealth } = useClub();

    const refresh = useCallback(async () => {
        await mutate();
        await reloadHealth?.();
    }, [mutate, reloadHealth]);

    return (
        <div className="flex flex-col gap-6">
            <Card>
                <CardHeader>
                    <ClubSettingsCardHeader
                        icon={PaletteIcon}
                        title="Personalização"
                        description="Identidade visual, domínio, banners, menu e detalhes do clube."
                    />
                </CardHeader>
            </Card>

            <Alert className="border-amber-500/50 bg-amber-500/15 px-4 py-3.5 text-amber-950 [&>svg]:size-5 [&>svg]:text-amber-600 dark:bg-amber-500/20 dark:text-amber-50 dark:[&>svg]:text-amber-400">
                <AlertTriangleIcon />
                <AlertTitle className="text-base font-semibold text-amber-950 dark:text-amber-50">
                    Alterações podem demorar um pouco
                </AlertTitle>
                <AlertDescription className="text-sm text-amber-900/90 dark:text-amber-50/85">
                    Depois de salvar, as mudanças podem levar até <strong>15 minutos</strong> para aparecer no app e no
                    site do clube. Se ainda não vir a alteração, aguarde um pouco e atualize a página.
                </AlertDescription>
            </Alert>

            <div className="flex flex-col gap-4">
                <DetailsClub data={data} mutate={refresh} />
                <DesignClub data={data} mutate={refresh} />
                <AppImageClub data={data} mutate={refresh} />
                <CardImageClub data={data} mutate={refresh} />
                <FeaturedHighlightClub />
                <BannersClubCard />
                <MenuClubCard />
                <SocialLinksClub data={data} mutate={refresh} />
                <SeoClub data={data} mutate={refresh} />
                <DominioClub data={data} mutate={refresh} />
            </div>
        </div>
    );
}
